import { render, staticRenderFns } from "./dashboard-notifications.vue?vue&type=template&id=02ec50aa&scoped=true&"
import script from "./dashboard-notifications.vue?vue&type=script&lang=js&"
export * from "./dashboard-notifications.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-notifications.vue?vue&type=style&index=0&id=02ec50aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec50aa",
  null
  
)

export default component.exports